/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import Header from "../../Common/Header";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import "./CreateAssessmentFinal.scss";
import useCreateAssessmentFinal from "./useCreateAssessmentFinal";
import MainLayout from "../../Common/MainLayout";

export default (props) => {
  const { formData, loading } = useCreateAssessmentFinal(props);
  return (
    <MainLayout>
      <div className="pb-5 create-interview-overview">
        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <div>
            <Container>
              <Row>
                <Col lg={12}>
                  <div className="border rounded p-4">
                    <div className="d-flex align-items-center mb-4">
                      <div className="border-radius-10 mr-3 company-logo mt-4 pt-1">
                        <img src={"/assets/images/logo.png"} alt="user" />
                      </div>
                      <h2>One-way video interview - {formData?.title}</h2>
                    </div>
                    <div className="inner-content">
                      <div className="row">
                        <div className="col-6"></div>
                        <div className="col-6 text-right">
                          <div className="alert alert-primary fs-smallest border-0 py-1 d-inline-block">
                            SUBMIT BY: {formData?.due_date}
                          </div>
                        </div>
                      </div>
                      <div className="text-grey-4">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: formData?.welcome_note,
                          }}
                        ></div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: formData?.epilogue_outro_note,
                          }}
                        ></div>
                      </div>

                      <div className="border-bottom py-4 text-grey-4">
                        <p className="text-dark-2 font-weight-semi">
                          Topics covered:
                        </p>
                        <ul className="mb-4">
                          {formData?.topics &&
                            Array.isArray(formData.topics) &&
                            formData.topics.map((item, index) => (
                              <li
                                className="d-flex align-items-center"
                                key={index}
                              >
                                <FontAwesomeIcon
                                  icon={faCircle}
                                  className="fs-6 mr-3"
                                />
                                {item?.name}
                              </li>
                            ))}
                        </ul>
                        <p className="text-dark-2 font-weight-semi">
                          Total questions: {formData?.total_question} •
                          Estimated time: {formData?.total_time} mins
                        </p>
                      </div>
                      <div className="py-4 text-grey-4">
                        <ul className="mb-4">
                          <li className="d-flex align-items-center">
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              className="text-primary mr-3"
                            />
                            After starting, you’ll have time to read the
                            question and record when you’re comfortable
                          </li>
                          {/* <li className="d-flex align-items-center">
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              className="text-primary mr-3"
                            />
                            You’re able to take breaks in between questions
                          </li> */}
                          <li className="d-flex align-items-center">
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              className="text-primary mr-3"
                            />
                            All recordings must be submitted by the specific
                            date
                          </li>
                        </ul>
                        <div className="actions d-flex align-items-center">
                          <button className="btn btn-light border">
                            Let’s practice first
                          </button>
                          <button className="btn ml-4 btn-primary ">
                            I’m ready, let’s start
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        )}
      </div>
    </MainLayout>
  );
};
